<template>
  <div>
    <Row style="width: 100%;margin-top:110px">
      <Col span="24" class="backImg">
          <!--<Carousel autoplay :autoplay-speed="3000" loop :radius-dot="true" :height="300">
            <CarouselItem v-for="item in carouselImg" :key='item.src'>
              <img :src="item.src" width="100%" height="100%">
            </CarouselItem>
          </Carousel>-->
            <img :src="img" width="100%">
      </Col>
    </Row>
   



<Row style="width: 100%;" class="FontLocal">
  <Col span="24" class="title">
      <span>上传信息</span><br />
  </Col>
</Row>





      <Row style="width: 100%;margin-top:50px">
      
              <Col span="24">
                  <Row><img :src="img2" width="80%"></Row>
                  <!-- <Row>
                    <Col></Col>
                    <Col></Col>
                  </Row> -->
             </Col>
      </Row>



      <Row>
        <Form :model="formLeft" label-position="left" :label-width="100" style="position:relative;left:640px;top:-340px">
                <FormItem label="公司名称">
                    <Input v-model="formLeft.input1" style="width:20%;left:-500px"></Input>
                </FormItem>
                <FormItem label="电子邮箱">
                    <Input v-model="formLeft.input2" style="width:20%;left:-500px"></Input>
                </FormItem>
                <FormItem label="姓名">
                    <Input v-model="formLeft.input3" style="width:20%;left:-500px"></Input>
                </FormItem>
                <FormItem label="联系电话">
                    <Input v-model="formLeft.input3" style="width:20%;left:-500px"></Input>
                </FormItem>
                <FormItem label="需求描述" prop="desc" >
                  <Input v-model="formLeft.desc" style="width:20%;left:-500px" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="Enter something..."></Input>
               </FormItem>
               <FormItem style="width:20%;margin-top:-60px;margin-left: 400px;">
                    <Button type="primary" style="left:-500px" @click="handleSubmit('formInline')">提交</Button>
              </FormItem>
            </Form>
      </Row>
     
  </div>
 
</template>
<script>
export default {
  data() {
    return {
       formLeft: {
                    input1: '',
                    input2: '',
                    input3: '',
                    desc: ''
                },
      info:23923,
      bid:115486,
      money:16745305.75,
      noticeList:[],
      data1: [],
      data2: [],
      data3: [],
      data4: [],
      carouselImg:[
        {src: "../../../../static/15.jpg",href: "www.baidu.com"},
        {src: "../../../../static/220.jpg",href: "www.baidu.com"},
        {src: "../../../../static/221.jpg",href: "www.baidu.com"},
        {src: "../../../../static/22.jpg",href: "www.baidu.com"}
      ],
      img: "../../../../static/officeImg/index/banner.webp",
      img2:"../../../../static/officeImg/applyConnect/write.png",
      img3:"../../../../static/officeImg/index/areacar.png",
      img4:"../../../../static/officeImg/index/areaSound.png",
      img5: "../../../../static/officeImg/index/shuju.png",
      img6:"../../../../static/officeImg/index/keyan.png",
      img7:"../../../../static/officeImg/index/zhuanjiatuanduiguanli.png",
      img8:"../../../../static/officeImg/index/gengxin.png",
      img9:"../../../../static/officeImg/index/01.jpg",
      img10:"../../../../static/officeImg/index/03.jpg",
      img11:"../../../../static/officeImg/index/02.jpg",
      img12:"../../../../static/officeImg/unit/cooperation1.png",
      img13:"../../../../static/officeImg/unit/cooperation2.png",
      img14:"../../../../static/officeImg/unit/cooperation3.png",
      img15:"../../../../static/officeImg/unit/cooperation4.png",
      img16:"../../../../static/officeImg/index/connectBac.png",
      mv1:"../../../../static/officeImg/index/总介绍.mp4"
      // img3: "../../../static/1.jpg",
      // img11: "../../../static/17.jpg",
      // img12: "../../../static/18.jpg"
    };
  },
   filters: {
        formatDate(time) {
            var date = new Date(time);
            return formatDate(date, "yyyy-MM-dd hh:mm");
        }
  },
  mounted() {
    this.loadData();
    //千位分割符
     this.money= this.toThousands(this.money,2);
  },
  methods: {
    loadData: function() {
    },
    Goto: function(type,id){
         switch (type) {
          case 'C01':
            {
              this.$router.push({ name: 'detail', query: { detailId: id}})
            }
            break;
          case 'C02':
            {
                this.$router.push({ name: 'detail2', query: { detailId: id}})
            }
            break;
          case 'C03':
            {
                this.$router.push({ name: 'detail1', query: { detailId: id}})
            }
            break;
         case 'C04':
            {
                this.$router.push({ name: 'detail3', query: { detailId: id}})
            }
            break;
            default:
            break;
        }
    },
    more: function() {
      this.$router.push({ path: "/item" });
    },
     //千位分割符
      toThousands: function(num,n, separator) {
     let parts;
     num = num + "";
     // 判断是否为数字
     if (!isNaN(parseFloat(num)) && isFinite(num)) {
    let nx;
         nx=Math.pow(10,n);

         num = (Math.round(num* nx) / nx).toFixed(n);


         parts = num.split('.');
         parts[0] = parts[0].toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + (separator || ','));

         return parts.join('.');
     }
     return NaN;
}
  }
};
</script>
<style scoped>
.backImg {
  background-color: white;
  width: 100%;
  font-size: 25px;
  /* text-align: center; */
  line-height: 30px;
  color: red;
  margin-top: 0px;
  margin-left: 0px;
}
.ImgLocal{
  position:relative;
  left:180px;
  margin-top:40px;
}
.HZImgLocal{
  position:relative;
  left:280px;
  margin-top:40px;
  margin-bottom: 120px;
}
.LYImgLocal{
  position: relative; 
  left:320px;
  margin-top:40px;
  margin-bottom: 120px;
}
.listItem:hover{
			border: #ededed 1px solid;
			box-shadow: 0 1px 6px #e8e8e8;
		}
		.slider .project_info .title{
			display: block;
			line-height: 85px;
		}
		.slider .project_info p{
			margin-bottom: 36px;
		}
		.dataQuDong .sec{
			display:none;
		}
		.dataQuDong>div:hover .sec{
			display:inline-block;
		}
		.dataQuDong>div:hover .fir{
			 display:none;
		 }
		.dataQuDong>div:hover{
             background-color:#6a4fe1;
			color:white;
		}
		.dataQuDong>div:hover p,.dataQuDong>div:hover h4{
			color:white;
		}
		#btn{ width:100px;height:40px; font-size:20px;border-radius:1110px;
			background:#ff6600; }
		#vido{top:0; left:0px;z-index:100}
		source{
			width:100%;
		}
		.connectBanner .contentBox {
			position: absolute;
			width: 1000px;
			height: 400px;
			text-align: center;
			padding: 15px;
      top: 40px;
    left: 280px;
		}

		.connectBanner .contentBox .content > div {
			position: absolute;
			left: 21%;
			top: 90%;
		}
		.connectBanner .contentBox .content {
			background: transparent;
			position: relative;
			width: 100%;
			height: 100%;
        /* background: transparent;
        position: relative;
        width: 100%;
        height: 100%;
        margin-top: -450px;
        margin-left: 210px; */
		}
.fontCSS {
    text-align: center;
    color: white;
    font-size: 23px;
    line-height: 40px;
    padding: 1% 0px;
    position: relative;
    left: 80px;
}



.FontLocal{
  margin-top:60px;
}
.title {
    text-align: center;
    color: rgb(0, 0, 0);
    font-size: 23px;
    line-height: 40px;
    padding: 1% 0px;
}
.li2 {
  width: 50%;
  font-size: 15px;
  margin-top: 6px;
}
.numInfo {
  background: white;
  font-size: larger;
  font-family: 微软雅黑;
  height: 100px;
  padding: 20px;
  box-shadow: 0.5px 0.5px 3px 0.5px darkgray;
}
.baseCard{
  background: white;
  font-family: 微软雅黑;
  box-shadow: 0.5px 0.5px 3px 0.5px darkgray;
  
}
.cardTitle{
  text-align: left;
  font-weight:540 !important;
  color: orange;
}

.li3 {
  width: 43%;
  font-size: 12px;
}
.icon-shuxian{
 font-size: 20px;
}
.shuxian{
  display:inline-block;
  width:4px;
  height: 22px;
  background: orange;
}
.icon-gengduo{
  color: orange;
}
.gengduo{
  font-family: 微软雅黑;
  color: rgb(120, 122, 123);
  font-size: 15px;
}
.wailian{
  font-size: 15px;
  font-weight:540;
  color:#787a7b;
}
</style>



// WEBPACK FOOTER //
// src/views/applyData/applyData.vue